// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2LhFd","legacyBtn":"MutateMid_legacyBtn__2SDiA"};